import Contact5 from './Contact5'
export default Contact5
